var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolarOrientation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.0884H5.74603M4.92063 5.95582L7.52381 8.65462M12.0317 3V6.79116M19.2063 5.95582L16.4762 8.65462M22 13.0884H18.3175M15.9048 13.4096C15.8413 12.0602 14.9511 9.29719 12.0317 9.29719C9 9.29719 8.22222 12.0174 8.15873 13.4096M2 16.5446H9.93651L12.0317 19.5004L14 16.5446H22",
    stroke: "#BF9A6D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarOrientation);
export default __webpack_public_path__ + "static/media/solar_orientation.4cde9115b5531b5ba9b7856480113c42.svg";
export { ForwardRef as ReactComponent };